<template>
    <section class="slice barometer-job__profiles">
        <div class="slice-content">
            <!-- eslint-disable-next-line vue/no-v-html -->
            <p v-html="text" />

            <div v-if="profiles.length" class="joy-mt-12">
                <h2 class="slice-title">{{ t('barometer.family.suggestions.profiles.title') }}</h2>
                <div class="slice-body">
                    <ProfilesCarousel data-testid="acquisition-carousel" class="text-left" :items="profiles" />
                    <div class="joy-mt-8">
                        <UncrawlableLink v-slot="{navigate}" custom external :to="searchUrl">
                            <VJoyButton variant="secondary" @click="navigate($event)">
                                {{ t('barometer.family.suggestions.profiles.search.label', [jobBarometer.jobLabelPlural]) }}
                            </VJoyButton>
                        </UncrawlableLink>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script setup lang="ts">
    import {inject} from 'vue';
    import {UncrawlableLink} from '#components';
    import {useLocalePrefix, useTranslation} from '#imports';
    import {VJoyButton} from '@maltjoy/core-vue';
    import ProfilesCarousel from '~/components/ProfilesCarousel.vue';
    import {BAROMETER_JOB} from '~/keys';

    const {t} = useTranslation();
    const {withLocalePrefix} = useLocalePrefix();
    const {jobBarometer} = inject(BAROMETER_JOB)!;

    const q = jobBarometer.query ?? jobBarometer.jobLabelPlural;
    const searchUrl = withLocalePrefix(`/s?q=${q}&fam=${jobBarometer.familyId}&cat=${jobBarometer.categoryId}&job=${jobBarometer.jobId}`);
    const tParams = [searchUrl, jobBarometer.nbFreelancers, jobBarometer.jobLabelPlural] as const;
    const text = t('barometer.family.suggestions.profiles.subtitle', tParams).replace('<a ', '<a class="link" rel="nofollow" ');

    const profiles = jobBarometer.results;
</script>

<style lang="scss">
    .barometer-job__profiles {
        .joy-button--slot {
            white-space: wrap;
        }
    }
</style>
